<template>
  <div>
    <div
      class="card-container mb-4 p-3"
      :class="{ 'ms-auto': index % 2 === 0 }"
    >
      <div>
        <div class="row">
          <div
            class="
              col-9
              d-flex
              justify-content-between
              align-items-center
              w-100
            "
          >
            <h5 class="card-title mb-0">
              {{ dataset.surveyGroupName }} ({{ dataset.total }})
            </h5>
            <h5 class="card-description text-uppercase mb-0">
              {{ dataset.year }}
              <span v-if="dataset.quarter !== undefined">
                - R{{ dataset.quarter.substring(1) }}</span
              >
            </h5>
          </div>
        </div>
        <div
          class="overall-score py-3 px-4 mt-3"
          :style="{ 'background-image': gradientColors(dataset.avgScore) }"
        >
          <h5 class="card-description text-capitalize mb-0">
            {{ type.toLowerCase() == "yes" ? "Engagement" : "Experience" }}
            score
          </h5>
          <h5 class="card-description text-capitalize mb-0">
            {{ dataset.avgScore.toFixed(2) }}
          </h5>
        </div>
        <router-link
          :to="{
            name: `${type == 'red' ? 'SurveyCoreQuestions' : 'Summary'}`,
            params: { id: dataset.surveyId },
          }"
        >
          <div v-if="dataset.modePersonaCountList" :class="classCard">
            <custom-bubble-chart
              v-if="type == 'yes'"
              :surveysData="dataset.modePersonaCountList"
              :class-card="classCard"
            />
            <bubble-chart
              v-else
              :class-card="classCard"
              :dataset="dataset.modePersonaCountList"
              :diameter="{ width: 15, height: 15 }"
            ></bubble-chart>
          </div>
        </router-link>

        <div class="card-information font-20">
          <ul class="list-unstyled">
            <template>
              <li
                v-for="item in dataset.modePersonaCountList"
                :key="item.type"
                class="pt-2 d-flex justify-content-between"
              >
                <div>
                  <span
                    class="item-color rounded-circle d-inline-block me-2"
                    :style="{
                      'background-color': modeOrPersonaColor(item.type),
                    }"
                  ></span>
                  <span>{{ item.type }}</span>
                </div>
                <div>
                  <span class="item-count me-3">{{ item.count }}</span>
                  <span class="item-percentage d-inline-block text-end"
                    >{{
                      Math.round(percentage(item.count, dataset.total))
                    }}%</span
                  >
                </div>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BubbleChart from "@/components/dashboard/surveys-charts/shared/bubble-chart.vue";
import CustomBubbleChart from "../surveys-charts/shared/custom-bubble-chart.vue";

export default {
  name: "CompletedSurveyCard",
  components: {
    BubbleChart,
    CustomBubbleChart,
  },
  props: {
    classCard: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    dataset: {
      type: Object,
      required: true,
    },
    from: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.card-container {
  background-color: $color-grey-100;
  border: $border-white-1;
  border-radius: $radius-25;
  opacity: 1;
  transition: $transition-400ms;
  // min-width: 25rem;
  max-width: 46.875rem;

  &:hover {
    background-color: $color-grey-85;
    box-shadow: 0 8px 16px #00000029;
    border-color: $color-grey-85;

    .card-information li {
      color: $color-white;
    }

    .percentage-close,
    .percentage-open {
      opacity: 1;
      visibility: visible;
    }
  }
}

.card-title {
  text-align: left;
  font-weight: $font-weight-semiBold;
  color: $color-white;
  opacity: 1;
}

.card-description {
  text-align: left;
  color: $color-white;
  opacity: 1;
}
.card-information {
  text-align: left;
  opacity: 1;

  li {
    color: #7e7e7e;
    border-bottom: $border-grey-60;
    transition: color 0.4s;
  }

  .percentage-close,
  .percentage-open {
    opacity: 0;
    visibility: visible;
    transition: opacity 0.4s;
  }

  .item-color {
    width: 0.625rem;
    height: 0.625rem;
  }
}
.item-percentage {
  width: 3.125rem;
}

.overall-score {
  border: $border-white-1;
  border-radius: $radius-25;
}
</style>
